import tw from 'twin.macro';
import { Route, Switch } from 'react-router-dom';
import './app.css';
import { ProtectedRoute } from 'modules/routes/protected-route';
import { ListAccounts } from 'modules/accounts/accounts-listing';
import { LoginPage } from 'modules/routes/login/login-page';
import { MainPage } from 'modules/main/main';
import { AccountDetailsPage } from 'modules/pages/account-details-page';
import { StoreOrderDetailsPage } from 'modules/pages/store-order-details-page';
import { TopupandPaymentDetailsPage } from 'modules/pages/topup-and-payment-details-page';
import { FuelOrderDetailsPage } from 'modules/pages/fuel-orders-details-page';

export const App = () => {
  return (
    <div css={tw`max-w-xs min-h-screen mx-auto relative `}>
      {/* Todo: logout button with absolute position */}
      <Switch>
        <ProtectedRoute path="/" exact>
          <MainPage />
        </ProtectedRoute>
        <Route path="/login">
          <LoginPage />
        </Route>
        <ProtectedRoute path="/accounts" exact>
          <ListAccounts />
        </ProtectedRoute>
        <ProtectedRoute path="/accounts/:userId">
          <AccountDetailsPage />
        </ProtectedRoute>
        <ProtectedRoute path="/store-orders/:userId/order/:orderId" exact>
          <StoreOrderDetailsPage />
        </ProtectedRoute>
        <ProtectedRoute path="/fuel-orders/:userId/order/:orderId" exact>
          <FuelOrderDetailsPage />
        </ProtectedRoute>
        <ProtectedRoute path="/topup-and-payment/:userId/topup/:transactionId">
          <TopupandPaymentDetailsPage />
        </ProtectedRoute>
      </Switch>
    </div>
  );
};
